<template>
    <modal 
        name="requestSuccessModal" 
        classes="v-modal-sec"
        :min-width="200"
        :min-height="200"
        :scrollable="true"
        :reset="true"
        width="500px"
        height="auto">
        <vs-popup class="holamundo success-popups" title="Your registration is complete."
      :active.sync="successModal">
       
      <figure>
        <img src="@/assets/images/main/icon-note.svg" alt="login" class="mx-auto" />
      </figure>
      <h2 class="title">{{successTitle}}</h2>
      
    </vs-popup>
    </modal>

</template>
<script>
import Vue from 'vue';

    export default {
        components:{
            
        },
        provide() {
            return {
                parentValidator: this.$validator,
            };
        },
        data: () => ({
            successModal:false
        }),
        props:{
            successTitle:{
                type:String,
                default:null
            },
           
        },
        methods:{
            
        },
        mounted(){
            this.successModal = true
            this.$modal.show('requestSuccessModal');
        }
    }


</script>